import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-dropzone',
  templateUrl: './dropzone.component.html',
  styleUrls: ['./dropzone.component.scss'],
})
export class DropzoneComponent implements OnInit {
  @Output() filesChange = new EventEmitter<FilePicked[]>();

  @Input() clearAttachments?: boolean = false;

  @Input() description: string =
    'O arquivo deve estar no formato PDF, JPG, JPEG, PNG, XLS ou XLSX. (1MB)';

  @Input() disabled: boolean = false;
  @Input() emitOnlyNewFiles: boolean = false;

  _files: FilePicked[] = [];

  set files(files: FilePicked[]) {
    this._files = files;
    this.filesChange.emit(this._files);
  }

  get files() {
    return this._files;
  }

  maxFileSize = 1024 * 1024 * 500;

  constructor(private toast: ToastService) {}

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.clearAttachments) {
      this.onRemove(this.files[0], new MouseEvent('click'));
    }
  }

  getFileUrl(file: File, callback: (url: string) => void) {
    const fileReader = new FileReader();

    fileReader.onload = (e: any) => {
      callback(e.target.result);
    };

    fileReader.readAsDataURL(file);
  }

  onSelect(event: any) {
    const addedFiles: File[] = event.addedFiles || [];
    if (addedFiles.length > 0) {
      // Uma única emissão por lote evita que o pai faça upload 1+2+3+… vezes
      // dos mesmos arquivos a cada item do forEach.
      void this.appendFilesBatch(addedFiles).catch((err) =>
        console.error('[app-dropzone] Falha ao processar arquivos:', err)
      );
    }

    if (event.rejectedFiles.length > 0) {
      const reason =
        event.rejectedFiles[0].reason === 'size' ? 'tamanho' : 'tipo';

      this.toast.show('error', 'Erro', `${reason} do arquivo inválido.`);
    }
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = (e: ProgressEvent<FileReader>) => {
        resolve(String(e.target?.result ?? ''));
      };
      fileReader.onerror = () => reject(fileReader.error);
      fileReader.readAsDataURL(file);
    });
  }

  private async appendFilesBatch(addedFiles: File[]): Promise<void> {
    const picked = await Promise.all(
      addedFiles.map(async (file: File) => {
        if (file.name.includes('.pdf')) {
          return { file, url: 'assets/images/pdf.png' } as FilePicked;
        }
        if (file.name.includes('.xls') || file.name.includes('.xlsx')) {
          return { file, url: 'assets/images/xls.png' } as FilePicked;
        }
        const url = await this.readFileAsDataUrl(file);
        return { file, url } as FilePicked;
      })
    );
    this.files = this.emitOnlyNewFiles ? picked : [...this.files, ...picked];
  }

  onRemove(file: FilePicked, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (file) {
      const newFiles = [...this.files];

      newFiles.splice(this.files.indexOf(file), 1);

      if (this.emitOnlyNewFiles) {
        this._files = newFiles;
        return;
      }

      this.files = newFiles;
    }
  }
}
